import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import Actions from '../../Actions';

function formatDate(date) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) { month = `0${month}`; }
  if (day.length < 2) { day = `0${day}`; }

  return [year, month, day].join('-');
}

export default function SummaryDownloadQuote({ plan }) {
  const [loadingPreview, setLoadingPreview] = useState(false);

  const values = {
    ...plan.attributes,
    effective_date: formatDate(plan.attributes.effective_date),
  };

  const onDownload = () => {
    setLoadingPreview(true);
    Actions.loadPdf(values, (pdf) => {
      setLoadingPreview(false);
      const file = new Blob([pdf], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      const link = document.createElement('a');
      link.href = fileURL;
      link.display = 'none';
      link.download = 'Talent Insurance Policy';
      // some browser needs the anchor to be in the doc
      document.body.append(link);
      link.click();
      link.remove();
    });
  };

  return (
    <section>
      <h2>Your Quote</h2>
      <div className="d-flex justify-content-between mb-3">
        <p>
          Click Download to save a detailed breakdown of your quote.
          <br />
          This Quote was created on
          {' '}
          {plan.attributes.created_date_formatted}
          . The Quote is valid for 30 days.
        </p>
        <Button
          className="align-self-start"
          onClick={onDownload}
        >
          {loadingPreview ? 'Download ...' : 'Download'}
        </Button>

      </div>
    </section>
  );
}

SummaryDownloadQuote.propTypes = {
  plan: PropTypes.object.isRequired,
};
